import { store } from '@spartalabs/pdc-core';

/** Same group/cost-center URL suffix used by pdc-core fleet report endpoints. */
export const getFleetGroupPath = () => {
  const currentGroupId = store.getState().authSlicer.user.currentGroupId;
  const costCenters = store.getState().authSlicer.user.costCenters;

  const baseCostCenters =
    costCenters
      ?.filter(center => center.groupId === currentGroupId)
      .flatMap(item => item.costCenters) ?? [];

  const uniqueCostCenters = baseCostCenters.reduce<
    { id: string | number; name: string }[]
  >((acc, item) => {
    if (!acc.some(center => center.id === item.id)) {
      acc.push(item);
    }
    return acc;
  }, []);

  const costCenterQuery = uniqueCostCenters
    .map(item => `costCenters=${item.id}`)
    .join('&');

  return `${currentGroupId}${
    costCenterQuery.length < 1 ? '' : `?${costCenterQuery}`
  }`;
};
